import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import MarkdownRenderer from 'react-markdown-renderer'
import ArtifactSize from '../mini/ArtifactSize'
import TargetDateIcon from '../mini/LevelQuest/TargetDateIcon/TargetDateIcon'
import colors from '../../configuration/colors'
import { P3 } from '../styled/typography/typography'

const SeeMentorInstructions = styled.a`
  color: ${colors.dove} !important;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
SeeMentorInstructions.displayName = 'SeeMentorInstructions'

const P3Description = styled(P3)`
  font-size: ${props => props.small ? '13px' : '15px'};
`

const ArtifactDescription = ({
  artifactDescription,
  artifactType,
  shouldHideDescription,
  targetDate,
  isStudentQuestActivity,
  isQuestCompleted
}) => {
  return (
    <P3 className="artifact-description markdown">
      <div className="icon">
        {artifactType && <ArtifactSize size={artifactType.name} />}
      </div>
      {!shouldHideDescription ? (
        <P3Description small={isStudentQuestActivity}
          className="desc">
          <span>
            {artifactDescription && artifactDescription.length > 0 ? (
              <MarkdownRenderer
                markdown={artifactDescription}
                options={{
                  linkTarget: '_blank'
                }}
              />
            ) : (
              'No artifact description provided.'
            )}
          </span>
        </P3Description>
      ) : (
        !isQuestCompleted &&
        targetDate !== undefined && (
          <TargetDateIcon targetDate={targetDate} shouldShowDate={true} />
        )
      )}
    </P3>
  )
}

ArtifactDescription.propTypes = {
  artifactDescription: PropTypes.string,
  artifactType: PropTypes.object,
  shouldHideDescription: PropTypes.bool,
  targetDate: PropTypes.object,
  isStudentQuestActivity: PropTypes.bool,
  isQuestCompleted: PropTypes.bool
}

export default ArtifactDescription
